module.exports = __webpack_public_path__ + "static/img/e5.0bdfd5bb.png";